import type { ChatMessage } from '../types/chat'

/** Client clock + IANA timezone for reminder parsing (typed chat + voice parity). */
export function clientReminderRuntimePayload(): {
  current_datetime_local: string
  timezone: string
} {
  const now = new Date()
  const y = now.getUTCFullYear()
  const mo = String(now.getUTCMonth() + 1).padStart(2, '0')
  const d = String(now.getUTCDate()).padStart(2, '0')
  const h = String(now.getUTCHours()).padStart(2, '0')
  const mi = String(now.getUTCMinutes()).padStart(2, '0')
  const se = String(now.getUTCSeconds()).padStart(2, '0')
  return {
    current_datetime_local: `${y}-${mo}-${d}T${h}:${mi}:${se}+00:00`,
    timezone: 'UTC',
  }
}

export function utteranceLooksLikeReminderStart(text: string): boolean {
  const raw = (text || '').trim()
  if (!raw) return false
  return /\b(remind\s+me|set\s+a\s+reminder|create\s+(?:a\s+)?reminder|make\s+(?:a\s+)?reminder|rappelle[\s-]?moi|rappelez[\s-]?moi)\b/i.test(
    raw,
  )
}

export function isReminderFlowInProgress(messages: readonly ChatMessage[]): boolean {
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i]
    if (m.role !== 'assistant' || m.historySnapshot) continue
    if (m.reminderConfirmed || m.reminderCancelled) return false
    if (m.awaitingRemindEditField || m.awaitingRemindConfirmation || m.remindFlowActive) return true
    return false
  }
  return false
}

export function shouldUseHostedChatForReminder(
  text: string,
  messages: readonly ChatMessage[],
): boolean {
  return utteranceLooksLikeReminderStart(text) || isReminderFlowInProgress(messages)
}
